import axios from "axios";
import { PaymentRequiredError } from "./errors";

export const request = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  withCredentials: true,
});

export const setRequestAccessToken = (token: string | null) => {
  request.defaults.headers.common["Authorization"] = token
    ? `Bearer ${token}`
    : "";
};

export const retryStrategy = (failureCount: number, error: Error) => {
  if (error instanceof PaymentRequiredError) {
    return false;
  }

  return failureCount < 3;
};
